import axios from "axios";

export const getUserAPIToken = () => {

    return localStorage.getItem('token');
}


export const risapi = axios.create({
 baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:3000",
 
});

export const getAxiosConfig = (appendHeader=null) => {

  let header = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      "Authorization": "Bearer " + getUserAPIToken()
  };
  if(appendHeader != null)
  {
      for(let ah in appendHeader)
      {
          header[ah] = appendHeader[ah];
      }
  }

  let axiosConfig = {
      headers: header
  };

  return axiosConfig;
}

export const  convertErrorKeyToObject = (existingObject,errorKey, errorMessage) => {
    const keys = errorKey.split('.');
    let result = existingObject;
    let currentObj = result;
  
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (i === keys.length - 1) {
        currentObj[key] = errorMessage; // Assign the error message to the last key
      } else {
        if (!currentObj[key]) {
          currentObj[key] = {}; // Create nested object if it doesn't exist
        }
        currentObj = currentObj[key]; // Move to the nested object
      }
    }
  
    return result;
  }


export const handleApiError = (response, setErrorSetter=null) => {
 
  response = response.response.data;
    if ("errors" in response) {
      let errors = response.errors;
      let errorKeys = Object.keys(errors);
      let errorObject = {}; // Create a new error object
      for (let index in errorKeys) {
        // console.log(errorKeys);
        if(errorKeys[index].includes("."))
        {
           
            errorObject = convertErrorKeyToObject(errorObject,errorKeys[index],errors[errorKeys[index]].join(","));
            
        }
        else
        {

            errorObject[errorKeys[index]] = errors[errorKeys[index]].join(",");
        }
      }
      console.log("errorobj",errorObject);
      
      setErrorSetter(errorObject); // Set the error using the provided setter
    } else if ("message" in response) {
      alert(process.env.REACT_APP_SERVER_ERROR_MESSAGE +  response.message);
    }
  };

  export const defaultFilterParameters = () => {
    return { paginate: false, searchTerm: '' };

}

  export const getAPIFullUrl = (path, filterParameters = null) => {

    let fullUrl =  path;
    if (filterParameters) {
        filterParameters = { ...defaultFilterParameters(), ...filterParameters };
        let loopCount = 0;
        for (let kf in filterParameters) {
            if (loopCount == 0) {
                fullUrl = fullUrl + '?' + kf + '=' + filterParameters[kf];
            }
            else {
                fullUrl = fullUrl + '&' + kf + '=' + filterParameters[kf];
            }
            loopCount++;
        }
    }

    console.log("fullurl=", fullUrl);
    return fullUrl;

}

export const printPDF = async (path,data,callback)=> {
  try {
      const response = await axios.post(process.env.REACT_APP_API_BASE_URL +  path,data, {
        responseType: 'blob', // Important: Get the response as a Blob
        headers: {
          Authorization: "Bearer " + getUserAPIToken()
        }
      });

      // Create a URL for the Blob
      const file = new Blob([response.data], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(file);
      // Open the PDF in a new tab and trigger printing

      // common solution
      const newWindow = window.open(pdfUrl, '_blank');
      if (newWindow) {
        newWindow.onload = () => {
          // newWindow.print();
        };
      } else {
        alert('Please allow pop-ups to print the PDF.');
      }

      callback(response.data);
      // end of common solution

      // in your react component
      // const link = document.createElement("a");
      // link.href = pdfUrl;
      // link.download = "club-walletTransactions-report.pdf";
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);

    } catch (error) {
       callback(error.response.data);
    }
}
export const printSpreadSheet = async (path,data,callback)=> {
  try {
      const response = await axios.post(process.env.REACT_APP_API_BASE_URL +  path,data, {
        headers: {
          Authorization: "Bearer " + getUserAPIToken()
        }
      });

      if (response.data.success) {
        const { file, filename, mimetype } = response.data;

        // Decode the base64 content
        const byteCharacters = atob(file);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        // Create a Blob from the byte array
        const blob = new Blob([byteArray], { type: mimetype });

        // Create a link element
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;

        // Append the link to the body and programmatically click it
        document.body.appendChild(link);
        link.click();

        // Clean up: remove the link and revoke the object URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);

        callback(response.data);
    } else {
        // setError('Error downloading Excel file: ' + (response.data.message || 'Unknown error.'));
    }

    } catch (error) {
       callback(error.response.data);
    }
}

